import { apiService } from "./api";

export interface CustomerServiceHistorySummary {
  customer_id: string;
  customer_name: string;
  customer_code: string;
  contact_number: string;
  total_visits: number;
  total_vehicles: number;
  total_invoiced: number;
  outstanding: number;
}

export interface CustomerServiceVisit {
  jobcard_id: string;
  jobcard_no: string;
  status: string;
  service_type: string;
  visit_number: number;
  vin_no?: string;
  vehicle_no?: string;
  vehicle_label?: string;
  date_in: string;
  date_out: string;
  salesman: string;
  technician: string;
  customer_complaint: string;
  receiver_name: string;
  receiver_mobile: string;
  invoice_amount: number | null;
  payment_status: string | null;
  parts_issued_count: number;
  qc_status: string | null;
  qc_ref: string;
  gate_pass_no: string;
  service_progress: string[];
}

export interface CustomerServiceHistoryResponse {
  success: boolean;
  summary?: CustomerServiceHistorySummary;
  visits?: CustomerServiceVisit[];
  message?: string;
}

export async function fetchCustomerServiceHistory(params: {
  customer_id?: string | null;
  vehicle_no?: string | null;
  vin_no?: string | null;
}): Promise<CustomerServiceHistoryResponse> {
  const query: Record<string, string> = {};
  if (params.customer_id && String(params.customer_id).trim()) {
    query.customer_id = String(params.customer_id).trim();
  }
  if (params.vehicle_no && String(params.vehicle_no).trim()) {
    query.vehicle_no = String(params.vehicle_no).trim();
  }
  if (params.vin_no && String(params.vin_no).trim()) {
    query.vin_no = String(params.vin_no).trim();
  }
  return apiService.get<CustomerServiceHistoryResponse>(
    "/pabws/customer/service-history",
    query,
    { includeAuthToken: true, authHeaderType: "Bearer" }
  );
}
